import { AxiosInstance } from 'axios'

export enum AgentVerificationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING_REVIEW = 'pending_review',
  PENDING_USER_VERIFICATION = 'pending_user_verification'
}

export const AgentVerificationRejectionReasonBucket = {
  Unclear: 'unclear',
  WrongDocument: 'wrong_document',
  InsufficientInformation: 'insufficient_information',
  Generic: 'generic'
} as const

export type AgentVerificationRejectionReasonBucket =
  typeof AgentVerificationRejectionReasonBucket[keyof typeof AgentVerificationRejectionReasonBucket]

export type AgentVerificationConfirmation = {
  id: string
  organisationId: string
  language: string
  validationRequestId: string
  title: string
  createdAt: string
  status: AgentVerificationStatus
  logo: string
  agentVerificationRedirectUrl: string
  partnerId: string
  configuration: { name: string }
}

export type AgentVerificationServiceCapabilities = {
  percentClient: AxiosInstance
}

export type AgentVerificationAssociation = {
  associationAlreadyRecorded: boolean
  partnerName: string
  language: string
}

export type PostAgentVerificationDocumentsParams = {
  agentVerificationId: string
  agentVerificationToken: string
  formData: FormData
}

export type AgentVerificationProgramType = 'education' | 'nonprofit' | 'social_impact'

export type AgentVerificationDocumentStatusResponse = {
  id: string
  status: AgentVerificationStatus
  hasUploadedDocuments: boolean
  partnerName: string
  organisationName: string
  partnerLogo: string | null
  partnerBanner: string | null
  rejectionReason: AgentVerificationRejectionReasonBucket | null
  attemptsRemaining: number
  documentReuploadEnabled: boolean
  awaitingDocumentUpload?: boolean
  programType?: AgentVerificationProgramType | null
}
